window.API_URL = "https://ibr-api.mycognitiva.io/V3.0/asistente";
window.API_REMEMBER = "https://ibr-api.mycognitiva.io/V3.0/campanas/NUEVOS_DIAS_ENVIO";
window.API_CUSTOMIZATION = "https://ibr-api.mycognitiva.io/V3.0/asistente/GET_CUSTOM";